import DualloHotSpotClient from "@/clients/duallo/DualloHotSpotClient";
import UpdateHotSpotModel from "@/domain/marker/UpdateHotSpotModel";

// Single owner of hotspot operations. Everything hotspot-related delegates to
// DualloHotSpotClient here; other services/components should call this rather than
// reaching for hotspot methods on AssetService.
class HotSpotService {

    async createHotSpot(hotSpot) {
        return await DualloHotSpotClient.createHotSpot(hotSpot);
    }

    async getHotSpotMarkersByAssetId(assetId) {
        return await DualloHotSpotClient.getHotSpotsByAssetId(assetId);
    }

    async getHotSpotMarkersByScanId(scanId) {
        return await DualloHotSpotClient.getHotSpotsByScanId(scanId);
    }

    async getHotSpotByIdAsync(scanId, hotSpotId) {
        return await DualloHotSpotClient.getHotSpotById(scanId, hotSpotId);
    }

    async getHotSpotAnomalies(scanId, hotSpotId) {
        return await DualloHotSpotClient.getHotSpotContainedAnomaliesById(scanId, hotSpotId);
    }

    async updateHotSpotMarker(modifiedHotSpot) {
        const request = new UpdateHotSpotModel(modifiedHotSpot);
        return await DualloHotSpotClient.updateHotSpot(request);
    }

    async updateHotSpotThumbnail(updateRequest) {
        return await DualloHotSpotClient.updateHotSpotThumbnail(updateRequest);
    }

    async deleteHotSpotAsync(hotSpot) {
        return await DualloHotSpotClient.deleteHotSpot(hotSpot);
    }
}

export default new HotSpotService();
